import { createAction } from "@coverme/redux";
import Axios from "axios";

export const search = query =>
    createAction("GET_SEARCH_RESULTS", () => {
        const customerId = query.customerId;
        let queryString = "";
        query.value=query.value.trim();
        // infers the search criteria
        // dateOfBirth?
        if (isValidDate(query.value)) {
            queryString = `dateOfBirth=${query.value}`;
        }
        // socialSecurityNumber?
        else if (/^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/.test(query.value)) {
            queryString = `socialSecurityNumber=${query.value}`;
        }
        else if (/^[0-9]*$/.test(query.value)) {
            queryString = `mrn=${query.value}`;
        }
        // an ordinary string will look up for firstname and lastname
        else {
            queryString = `firstName=${query.value}&lastName=${query.value}`;
        }

        // adds the customer criteria
        queryString += `&customerIds=${customerId}`;

        return Axios.get(`/api/customer/${customerId}/persons/search?${queryString}`).then(res => res.data);
    });

    /***
     * Validates dates on us format
     * @param dateString string to e validated
     * @returns {boolean} .
     */
    function isValidDate(dateString)
    {
        // First check for the pattern
        if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
            return false;
    
        // Parse the date parts to integers
        var parts = dateString.split("/");
        var day = parseInt(parts[1], 10);
        var month = parseInt(parts[0], 10);
        var year = parseInt(parts[2], 10);
    
        // Check the ranges of month and year
        if(year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;
    
        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
    
        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;
    
        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    };